import { Visibility } from "@material-ui/icons";
import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useMemo, useState } from "react";
import {
    Col,
    FloatingLabel,
    Form,
    InputGroup
} from "react-bootstrap";
import { useGetDivisionListQuery } from "../../../features/Dispatch/DispatchSlice";
import RadioButton from "../../designSystem/RadioButton";
import OrderDetailsMin from "../../Dispatch/SamedayDispatch/OrderDetails/OrderDetailsMin";
import Wrapper from "../../Wrapper";

const dummyData = [
    {
        id: 1,
        readyDate: "2025-01-21 10:00:00 AM",
        vehicle: "Truck",
        service: "Express",
        consignorName: "John Doe",
        pickupCity: "New York",
        consigneeName: "Jane Smith",
        dropoffCity: "Los Angeles",
        pickupDriver: "Mike Johnson",
    },
    {
        id: 2,
        readyDate: "2025-01-21 2:30:00 PM",
        vehicle: "Van",
        service: "Standard",
        consignorName: "Alice Brown",
        pickupCity: "Chicago",
        consigneeName: "David Wilson",
        dropoffCity: "Houston",
        pickupDriver: "Robert Lee",
    },
    {
        id: 3,
        readyDate: "2025-01-22 9:15:00 AM",
        vehicle: "Bike",
        service: "Same Day",
        consignorName: "Charlie Adams",
        pickupCity: "San Francisco",
        consigneeName: "Eve Thomas",
        dropoffCity: "Seattle",
        pickupDriver: "Chris Evans",
    },
];

const weekdays = [
    "All",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
];

const ProcessPrebookedOrders = () => {
    const { data: divisionList } = useGetDivisionListQuery();
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [divisionId, setDivisionId] = useState(null);
    const [RadioValue, setRadioChange] = useState("All");
    const [selectedDay, setSelectedDay] = useState("All");

    const columns = useMemo(
        () => [
            {
                field: "actions",
                headerName: "Actions",
                width: 80,
                renderCell: (params) => {
                    const onClick = async (e) => {
                        e.stopPropagation();
                        setSelectedOrder({
                            orderId: 1044,
                            orderNumber: 10000799,
                            orderStatus: "Open",
                            readyDate: "2024-12-19 01:00",
                            emailAddress: "jtesttt@lvm.com",
                            accountNo: "TST0361",
                            customer: "tst",
                            consignorName: "Express Ltd",
                            pickupStreetNumber: 5026,
                            pickupStreetName: "Service Rd",
                            pickupUnit: "120",
                            pickupCity: "Burlington",
                            pickupCountry: "CAN",
                            pickupProvince: "ON",
                            pickupPostalCode: "L7L 5Y7",
                            pickupPhoneNumber: "4789568456",
                            pickupDriver: null,
                            pickupAppointment: "2024-03-11T15:21",
                            pickupContact: "Roseee",
                            pickupOpeningTime: "2023-11-16T13:00:00.000Z",
                            pickupClosingTime: "2023-11-16T23:30:00.000Z",
                            pickupContactEmail: "sam@ex.com",
                            pickupReference: null,
                            consigneeName: "Jisna",
                            dropoffStreetNumber: 123,
                            dropoffStreetName: "Drew",
                            dropoffUnit: "100",
                            dropoffCity: "Abbeville",
                            dropoffCountry: "CAN",
                            dropoffProvince: "AB",
                            dropoffPostalCode: "L6Y 5Y6",
                            dropoffPhoneNumber: "4587459856",
                            dropoffDriver: null,
                            dropoffAppointment: "2024-03-12T17:01",
                            dropoffContact: "JISNA",
                            dropoffOpeningTime: "2024-02-13T05:30:00.000Z",
                            dropoffClosingTime: "02:00",
                            dropoffContactEmail: "j@lvm.com",
                            dropoffReference: null,
                            vehicle: "CWTVEHICLE",
                            service: "DISTRIBUTION",
                            pcs: 1,
                            weight: 222,
                            weightTypeId: 2,
                            reference: "1000",
                            accessorialCode: "",
                            unit: "0",
                            spot: "0",
                            ft: "0",
                            dimWgt: "0",
                            accountInformationNotes: "null",
                            pickupInformationNotes: null,
                            dropoffInformationNotes: null,
                            pickupAccessorialCodes: [],
                            dropoffAccessorialCodes: [],
                            orderLevelAccessorialCodes: [],
                            dispatcherNotes: null,
                            tripNo: null,
                            pickupPriority: null,
                            dropoffPriority: null,
                            expiryTime: "",
                            orderProductDescriptionsList: [],
                        });
                    };

                    return (
                        <div className="action_btn">
                            <span className="view_btn" onClick={onClick}>
                                <Visibility />
                            </span>
                        </div>
                    );
                },
            },
            { field: "readyDate", headerName: "Ready Date", width: 200 },
            { field: "vehicle", headerName: "Vehicle Type", width: 120 },
            { field: "service", headerName: "Service Type", width: 120 },
            { field: "consignorName", headerName: "Consignor Name", width: 120 },
            { field: "pickupCity", headerName: "Pickup City", width: 120 },
            { field: "consigneeName", headerName: "Consignee Name", width: 120 },
            { field: "dropoffCity", headerName: "Dropoff City", width: 120 },
            { field: "pickupDriver", headerName: "Pickup Driver", width: 120 },
        ],
        []
    );

    const rows = useMemo(() => {
        return dummyData?.map((order) => ({
            id: order.id,
            ...order,
            readyDate: new Date(order.readyDate).toLocaleString(),
        }));
    }, []);

    const handleRadioChange = (e) => setRadioChange(e.target.value);
    const handleSelectWeekday = (e) => setSelectedDay(e.target.value);
    const handleSelectDivision = (e) => setDivisionId(e.target.value);

    return (
        <Wrapper>
            <h3>Process Prebooked Orders</h3>


            <Col md={12} className="d-flex flex-column flex-lg-row  justify-content-between table-back p-3 mb-3 align-items-center">
                <Col xs={12} lg={5} className="mb-3 mb-lg-0">
                    <div className="d-flex gap-2">
                        <Col md={8}>
                            <InputGroup className="h-100">
                                <InputGroup.Text
                                    style={{ backgroundColor: "#f6f6f6", border: 0 }}
                                >
                                    <span>
                                        <i className="fa fa-search" aria-hidden="true"></i>
                                    </span>
                                </InputGroup.Text>
                                <Form.Control
                                    type="text"
                                    placeholder="Search"
                                    // value={searchValue}
                                    // onChange={handleGlobalSearch}
                                    style={{
                                        border: 0,
                                        borderRadius: "0 4px 4px 0",
                                        backgroundColor: "#f6f6f6",
                                    }}
                                />
                            </InputGroup>
                        </Col>

                        <Col md={4}>
                            <FloatingLabel controlId="floatingSelectGrid" label="Select division">
                                <Form.Select
                                    aria-label="Floating label select example"
                                    name="divisionId"
                                    value={divisionId || ""}
                                    onChange={handleSelectDivision}
                                >
                                    <option value="">Select</option>
                                    {divisionList?.data?.map((data, index) => (
                                        <option key={index} value={data?.divisionId}>
                                            {data?.divisionName}
                                        </option>
                                    ))}
                                </Form.Select>
                            </FloatingLabel>
                        </Col>
                    </div>
                </Col>

                <Col xs={12} lg={6} xxl={5}>
                    <div className="d-flex gap-2">
                        <Col md={8}>
                            <div className="d-flex align-items-center gap-3 border rounded px-3 py-2 h-100">
                                <RadioButton
                                    label="All"
                                    name="orderType"
                                    value="All"
                                    checked={RadioValue === "All"}
                                    onChange={handleRadioChange}
                                />
                                <RadioButton
                                    label="Recurring"
                                    name="orderType"
                                    value="Recurring"
                                    checked={RadioValue === "Recurring"}
                                    onChange={handleRadioChange}
                                />
                                <RadioButton
                                    label="Non-recurring"
                                    name="orderType"
                                    value="Non-recurring"
                                    checked={RadioValue === "Non-recurring"}
                                    onChange={handleRadioChange}
                                />
                            </div>
                        </Col>
                        <Col md={4}>
                            <FloatingLabel controlId="floatingSelectWeekdays" label="Select Day">
                                <Form.Select
                                    aria-label="Floating label select weekdays"
                                    value={selectedDay}
                                    onChange={handleSelectWeekday}
                                >
                                    {weekdays.map((day, index) => (
                                        <option key={index} value={day}>
                                            {day}
                                        </option>
                                    ))}
                                </Form.Select>
                            </FloatingLabel>
                        </Col>
                    </div>
                </Col>
            </Col>
            {selectedOrder && (
                <OrderDetailsMin
                    selectedOrder={selectedOrder}
                    setSelectedOrder={setSelectedOrder}
                    divisionId={divisionId}
                    shouldShowGrossPriceSection
                />

            )}
            <Box sx={{ height: 600, width: "100%" }} className="table-back">
                <DataGrid rows={rows} columns={columns} />
            </Box>
        </Wrapper>
    );
};

export default ProcessPrebookedOrders;
